import { SET_PRODUCT_EDIT_LANGUAGE } from './types';

export const setEditLanguage = lng => (dispatch) => {
  dispatch({ type: SET_PRODUCT_EDIT_LANGUAGE, payload: { productLanguage: lng } });
};

export default setEditLanguage;
